import { Sparkles, User2 } from 'lucide-react'
import type { AssistantTurn } from '../hooks/use-assistant-chat'
import { ProposedChangesCard } from './proposed-changes-card'
import { SimpleChangesCard } from './simple-changes-card'

interface Props {
  turn: AssistantTurn
  mode: 'simple' | 'advanced'
  onAccept: () => void
  onReject: () => void
}

export function AssistantChatMessage({ turn, mode, onAccept, onReject }: Props) {
  const Card = mode === 'advanced' ? ProposedChangesCard : SimpleChangesCard
  // Q&A turns (assistant just answered, no mutation) carry an empty patch.
  // No confirm box in that case — only render the card when there is an
  // actual proposal or validation issues the user must see.
  const hasProposal = !!turn.result && (
    (turn.result.patch?.length ?? 0) > 0 ||
    (turn.result.validation_report?.issues?.length ?? 0) > 0
  )
  return (
    <div className="flex gap-2 items-start">
      <div className="mt-0.5 shrink-0">
        {turn.role === 'user'
          ? <User2 className="w-4 h-4 text-muted-foreground" />
          : <Sparkles className="w-4 h-4 text-primary" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm leading-relaxed whitespace-pre-wrap">{turn.content}</div>
        {hasProposal && turn.result && (
          <Card
            result={turn.result}
            accepted={turn.accepted ?? null}
            onAccept={onAccept}
            onReject={onReject}
          />
        )}
      </div>
    </div>
  )
}
